import {
  Application,
  Container,
  FillGradient,
  Graphics,
  Sprite,
  Texture,
} from "pixi.js";

const colorStops = [
  { y: Number.MAX_VALUE, color: { r: 0, g: 212, b: 255 } },
  { y: 1000, color: { r: 0, g: 212, b: 255 } },
  { y: -1000, color: { r: 0, g: 9, b: 79 } },
  { y: -3000, color: { r: 0, g: 0, b: 24 } },
  { y: -Number.MAX_VALUE, color: { r: 0, g: 0, b: 0 } },
];

type RgbColor = {
  r: number;
  g: number;
  b: number;
};

const avgColor = (
  a: RgbColor,
  weightA: number,
  b: RgbColor,
  weightB: number,
): RgbColor => {
  return {
    r: a.r + (b.r - a.r) * (weightA / (weightA + weightB)),
    g: a.g + (b.g - a.g) * (weightA / (weightA + weightB)),
    b: a.b + (b.b - a.b) * (weightA / (weightA + weightB)),
  };
};

export const background = (app: Application, stage: Container) => {
  const gradient = new Graphics();

  const buildGradient = (height: number) => {
    const gradientFill = new FillGradient(0, 0, 0, app.canvas.height);

    const stops = [height - 500, height + app.canvas.height + 500];

    stops.forEach((h, i) => {
      const colorAbove = colorStops[colorStops.findIndex((s) => s.y < h) - 1];
      const colorBelow = colorStops.find((s) => s.y < h);

      const mid = avgColor(
        colorAbove.color,
        Math.abs(h - colorAbove.y),
        colorBelow.color,
        Math.abs(h - colorBelow.y),
      );
      gradientFill.addColorStop(1 - i, mid);
    });

    return gradientFill;
  };

  const container = new Container();
  const g = buildGradient(stage.localTransform.ty);
  gradient.clear();
  gradient.rect(0, 0, app.canvas.width, app.canvas.height).fill(g);

  let oldG: FillGradient;
  let oldHeight: number;

  app.ticker.add(() => {
    if (oldHeight === stage.localTransform.ty) {
      return;
    }
    oldHeight = stage.localTransform.ty;
    const g = buildGradient(stage.localTransform.ty);
    gradient.clear();
    gradient.rect(0, 0, app.canvas.width, app.canvas.height).fill(g);
    if (oldG?.texture !== undefined) {
      oldG.texture.destroy(true);
    }
    oldG = g;
  });

  container.addChild(gradient);
  container.addChildAt(shite(app), 1);
  container.zIndex = -10000;
  return container;
};

const shite = (app: Application) => {
  let dx = 0;
  let dy = 0;
  let offsetX = 0;
  let offsetY = 0;
  const container = new Container();
  for (let i = 0; i < 10000; i++) {
    const shprite = new Sprite(Texture.WHITE);

    shprite.alpha = Math.random() / 2;
    shprite.width = 3 * Math.random();
    shprite.height = shprite.width;
    shprite.zIndex = -1000;

    shprite.x = Math.random() * 10000 - 5000;
    shprite.y = Math.random() * 10000 - 5000;
    container.addChild(shprite);
  }

  app.ticker.add((t) => {
    if (Math.random() < 0.05) {
      dx += Math.round(1.5 - Math.random() * 3);
      dy += Math.round(1.5 - Math.random() * 3);
      dx = Math.min(dx, 5);
      dy = Math.min(dx, 5);
    }
    offsetX += dx * t.deltaMS * 0.005;
    offsetY += dy * t.deltaMS * 0.005;

    container.updateTransform({ x: offsetX, y: offsetY });
  });
  return container;
};
